export default {
  INVALID_FLASH_VERSION : 'Error loading player: Flash version must be 11.2 or greater'
};



/** WEBPACK FOOTER **
 ** ./src/errorCodes.js
 **/